
class ProductWarehouseDataSource extends MIOObject
{
    private tableView:UITableView = null;
    initWithTableView(tableview:UITableView){
        this.tableView = tableview;
    }

    private _product:Product = null;
    set product(product:Product){
        this._product = product;
        this.fetchedResultsController = null;
        this.mapProductWarehouses(this.fetchedResultsController.fetchedObjects);
        this.tableView.reloadData();
    }

    numberOfSections(tableview:UITableView){
        // return this.fetchedResultsController.fetchedObjects.length;
        return 1;
    }

    numberOfRowsInSection(tableview:UITableView, section:number){
        // let sec = this.fetchedResultsController.sections[section];
        // return sec.numberOfObjects();
        // let item = this.fetchedResultsController.fetchedObjects[section];
        // return item.warehouseLocations.length;
        return this._items.length;
    }

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){        
        let item = this._items[indexPath.row];
        let cell_id = item.Type == "PW" ? "WarehouseCell" : "WarehouseLocationCell";
        let cell = tableview.dequeueReusableCellWithIdentifier( cell_id ) as ProductWarehouseStockCell;
        // let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as ProductWarehouse;
        cell.item = item;            
        return cell;
    }

    editingStyleForRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {   
        let item = this._items[indexPath.row];
        if (item.Type == "PWL") return UITableViewCellEditingStyle.None;

        return UITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView:UITableView, editingStyle:UITableViewCellEditingStyle, indexPath:MIOIndexPath) {        

        let item = this._items[indexPath.row];
        if (item.Type == "PWL") return;

        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            DBHelper.deleteObjectFromMainContext(item["PW"], true);
        }
    }

    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }
    
    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;
    
        let ad = MUIWebApplication.sharedInstance().delegate;
        
        let sd = [MIOSortDescriptor.sortDescriptorWithKey("name", false)];
        let predicateFormat = 'product.identifier = ' + this._product.identifier;
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("ProductWarehouse", sd, predicateFormat);
        fetchRequest.relationshipKeyPathsForPrefetching = ["warehouse.warehouseLocations", "product.productWarehouseLocations"];
        
        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;            
        
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;    
        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller:MIOFetchedResultsController){
        this.mapProductWarehouses( controller.fetchedObjects);
        this.tableView.reloadData();
    }

    // Map all fetch objects to flat the result
    private _items:any = [];
    private mapProductWarehouses(objects:ProductWarehouse[]){
        this._items = [];
        for (let wh_index = 0; wh_index < objects.length; wh_index++){
            let pw = objects[wh_index] as ProductWarehouse;
            let i = {"LevelPath": pw.warehouse.name, "Type": "PW", "PW": pw };
            this._items.addObject(i);

            let warehouse_locations = pw.warehouse.warehouseLocations.allObjects;
            for (let wl_index = 0; wl_index < warehouse_locations.length; wl_index++){
                let wl = warehouse_locations[wl_index] as WarehouseLocation;
                let i = {"LevelPath": pw.warehouse.name + "." + wl.name, "Type": "WL", "WL": wl, "P": this._product };

                let pwls = this._product.productWarehouseLocations.allObjects.filter((pwl:ProductWarehouseLocation) => {
                    if (pwl.product.identifier == this._product.identifier && pwl.warehouseLocation.identifier == wl.identifier) return pwl;
                });

                if (pwls.length > 0) i["PWL"] = pwls[0];

                this._items.addObject(i);
            }
        }
    }
}